(function () {
    "use strict";

    /**
     * The entry point of the site agnostic sitecat/analytics implementation
     * All site specific configuration and metrics should be passed into the constructor
     * Created by maktarh on 23/03/2017.
     * @constructor
     */
    function Analytics(sitecatConfig) {

        this.configuration = sitecatConfig;
        this.sharedMetrics = window.nadex.marketing.analytics.sharedMetrics;
        this.cookie = window.nadex.marketing.analytics.cookie;
        this.plugins = [];
    }

    /**
     * Writes out the code and fires the main page load event
     * @function
     */
    Analytics.prototype.triggerSiteCat = function () {

        //console.log("nadex analytics: triggerSiteCat fired");

        var sCode;
        if (window.s) {
            sCode = s.t(); //call to page tracking
            //console.log("nadex analytics: s.t() called");
            if (sCode) {
                document.write(sCode);
                //console.log("nadex analytics: tracking called");
            } else {
                //console.error("nadex analytics: sCode is false");
            }
        } else {
            //console.error("nadex analytics: window.s is false");
        }
    };


    /**
     * @function - sends events to sitecatalyst. Call once per event. Doesn't cause a page impression
     * @param eventName - the name of the event e.g. "event85"
     * @param message - a message to include in the event call to help identify it
     * @param metrics - associated metrics that need to be captured to provide additional information around the event.
     *                  An array of objects with name and value properties
     */
    Analytics.prototype.trackEvent = function (eventName, message, metrics) {

        //console.log("trackEvent fired: ", eventName);

        var linkTrackVars = 'events,eVar61,eVar22,eVar53';
        var metric;
        var crossSiteId = window.nadex.marketing.analytics.cookie.get("x_userid");

        if (window.s) {
            if (metrics) {
                for (var i = 0; i < metrics.length; i++) {
                    metric = metrics[i];
                    if (metric.hasOwnProperty("value") && metric.hasOwnProperty("name")) {
                        s[metric.name] = metric.value;
                        linkTrackVars += ',' + metric.name;
                    }
                }
            }
            s.linkTrackVars = linkTrackVars;
            s.linkTrackEvents = eventName;
            s.eVar22 = this.configuration.getSiteConfig().mainReportSuite;
            s.events = eventName;
            s.eVar61 = this.cookie.get('evar61');
            if (crossSiteId.length > 0) {
                s.eVar53 = crossSiteId;
            }
            s.tl(true, 'o', message);
        }

    };


    /**
     * @function - sends pageimpression to sitecatalyst. Used by the application forms
     * @param sectionName - the name of the section, can be either "application form" or "demo app form"
     * @param pageName - name of the current page or step in the form, for example "Page 1", "Page 2", "Page N"
     */
    Analytics.prototype.trackAppFormStep = function (sectionName, pageName) {

        if (window.s) {
            if (sectionName && pageName) {
                console.log("nadex analytics: app form section: " + sectionName + ", app form page: " + pageName);  
                console.log("nadex analytics: existing window.s vars:", window.s);
                //s.clearVars(); 
                s.pageName = sectionName.toLowerCase() + ":" + pageName.toLowerCase();

                switch (s.pageName) {
                    case 'application form:page 1':
                        console.log("nadex analytics: page 1, event35 set");
                        s.events = "event35";
                        break;
                    case 'application form:page 2':
                        console.log("nadex analytics: page 2, event36 set");
                        s.events = "event36";
                        break;
                    case 'application form:page 3':
                        console.log("nadex analytics: page 3, event37 set");
                        s.events = "event37";
                        break;
                    case 'application form:page 4':
                        console.log("nadex analytics: page 4, event38 set");
                        s.events = "event38";
                        break;
                    case 'application form:page 5':
                        console.log("nadex analytics: page 5, event39 set");
                        s.events = "event39";
                        break;                                                            
                    default:
                        console.log("nadex analytics: not app form step");
                }  

                s.t();              
            } else {
                console.log("nadex analytics: no app form attributes passed");
            }
        }

    };    


    /**
     * Set up all general tracking configuration and tries to initialise any custom metrics
     * @function
     */
    Analytics.prototype.initialise = function () {

        //console.log("nadex analytics: initialise");

        var configuration = this.configuration.getSiteConfig();
        var reportSuites = configuration.mainReportSuite;

        if (configuration.rollupReportSuite.length > 1) {
            reportSuites += ',' + configuration.rollupReportSuite;
        }

        window.s = s_gi(reportSuites);

        window.s.visitor = Visitor.getInstance(configuration.organisationId);

        s.trackingServer = configuration.trackingDomain;
        s.trackingServerSecure = 's' + configuration.trackingDomain;

        //UUID
        var tracking_id = window.nadex.marketing.analytics.cookie.get('evar61');
        window.s.loadModule("AudienceManagement");
        if ( tracking_id ) {

            //console.log("nadex analytics: evar61 found");

            window.s.visitor.setCustomerIDs({
                "tracking_id":{
                    "id": tracking_id,
                    "authState":Visitor.AuthState.LOGGED_OUT //client is not logged in but tracking ID is still available
                }
            });
        }

        window.nadex.marketing.analytics.sitecatalyst = window.s;
        return this.sharedMetrics.initialise(window.s, configuration);
    };

    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.GenericAnalytics = Analytics;
}());